import { makeNodeName } from '~/components/ktable/utils';
import { BaseController } from '~/utils/base-controller';

/* globals angular, Dashboard, Ktable */

/**
 * @implements {angular.IController}
 */
export default class KtableSettings extends BaseController {
	/**
	 * bindings
	 * @type {any}
	 */
	widget;

	/** @type {Dashboard.KTableWidgetOptionsOptions} */
	settings

	/** @type {any} */
	parent

	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 */
	constructor(
		$injector,
	) {
		super($injector);

		this.sortTypes = [{
			title: 'Croissant',
			value: 'ASC',
		},
		{
			title: 'Décroissant',
			value: 'DESC',
		},
		];

		/** @type {{title: string, value: Ktable.Visibility['visibility']}[]} */
		this.visibilityType = [{
			title: 'Visible',
			value: 'visible',
		},
		{
			title: 'Invisible',
			value: 'hidden',
		},
		];

		const numbers = [
			'K_NODE;NUMBER',
			'K_NODE;INTEGER',
			'K_NODE;FLOAT',
			'K_NODE;DOUBLE',
		];

		const strings = [
			'K_NODE;STRING',
			'K_NODE;TEXT',
		];

		const virtual = 'virtual';

		/** @type {any} */
		this.binding = [{
			allow: [],
			value: null,
			title: 'Aucun',
		},
		{
			allow: [
				...numbers,
				virtual,
			],
			value: 'sum',
			title: 'Somme',
		},
		{
			allow: [
				...numbers,
				virtual,
			],
			value: 'avg',
			title: 'Moyenne',
		},
		{
			allow: [
				...numbers,
				virtual,
			],
			value: 'min',
			title: 'Minimum',
		},
		{
			allow: [
				...numbers,
				virtual,
			],
			value: 'max',
			title: 'Maximum',
		},
		{
			allow: [...strings, ...numbers, virtual],
			value: 'notEmpty',
			title: 'Non vide',
		},
		];

		this.settings = {
			calculation: [],
			options: {
				actions: {
					copy: true,
					insertCreate: false,
					insertExisting: false,
					viewCell: true,
				},
			},
			sorts: [],
			visibility: [],
		};

		/** @type {import('~/scripts/services/model/query-column').default[]} */
		this.query = [];

		this.tab = 'calculations';
	}

	/**
	 *
	 * @param {string} columnId
	 */
	calculationTypes(columnId) {
		if (!columnId) {
			return [];
		}

		const column = this.query.find(c => c.id === columnId);

		if (column) {
			let {
				type,
			} = column;
			const {
				op,
			} = column;

			if (op === 'count') {
				type = 'K_NODE;NUMBER';
			}

			if (column.type) {
				return this.binding.filter((/** @type {any} */ b) => b.allow.length === 0 || b.allow.includes(type));
			}
		}

		throw new Error('Column not found');
	}

	/**
	 * @param {import('~/scripts/services/model/query-column').default} column
	 * @returns {string}
	 */
	makeNodeName(column) {
		return makeNodeName(column, this.$translate);
	}

	$onInit() {
		if (this.widget?.options?.data) {
			this.settings = {
				...this.settings,
				...this.widget.options.data,
			};

			if (!this.settings.calculation || !Array.isArray(this.settings.calculation)) {
				this.settings.calculation = [];
			}

			if (!this.settings.visibility || !Array.isArray(this.settings.visibility)) {
				this.settings.visibility = this.query.map(c => {
					return {
						column:     c.id ?? '',
						visibility: 'visible',
					};
				});
			}
		}

		this.parent.widgetData = this.settings;

		this.query = this.widget.query.select;
	}

	addSortLine() {
		this.settings.sorts.push({
			value: null,
			type: 'ASC',
		});
	}

	addCalcLine() {
		this.settings.calculation.push({
			column: null,
			type: null,
		});
	}

	addVisibilityLine() {
		this.settings.visibility.push({
			column: null,
			visibility: 'visible',
		});
	}

	/**
	 * @param {number} index
	 */
	removeSortLine(index) {
		this.settings.sorts.splice(index, 1);
	}

	/**
	 * @param {number} index
	 */
	removeCalcLine(index) {
		this.settings.calculation.splice(index, 1);
	}

	/**
	 * @param {number} index
	 */
	removeVisibilityLine(index) {
		this.settings.visibility.splice(index, 1);
	}

	getErrors() {
		/** @type {any[]} */
		const failures = [];

		/** @type {any[]} */
		const warnings = [];

		// TODO: check if multiple sorts on the same column

		this.parent.isValid = failures.length === 0;

		return [...failures, ...warnings];
	}

	errorCount() {
		return this.getErrors().length;
	}

	getErrorsAsString() {
		return this.getErrors().join(', ');
	}
}
